// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3X-zF","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2lw8y"};